// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c464c73f","453":"6cc0bef7","667":"76da8b31","977":"1b4d4973"}[chunkId] + ".chunk.js";
};